import firebase from "../services/FirebaseService";

export default class AuthService {

	async signUpEmail(email, name, password, repeatPassword) {
		if(email.length === 0 || name.length === 0 || password.length === 0 || repeatPassword === 0) {
			throw new Error("Please fill all the fields");
		}
		else if(password !== repeatPassword) {
			throw new Error("Both passwords don't match");
		}
		else {
			try {
				const userCredentials = await firebase.auth().createUserWithEmailAndPassword(email, password);

				userCredentials.user.updateProfile({
					displayName: name
				});

				await firebase.firestore().collection("users").doc(userCredentials.user.uid).set({
					name: name
				});

				await userCredentials.user.sendEmailVerification();

			}
			catch({ code }) {
				if(code === "auth/email-already-in-use") {
					throw new Error("Both passwords don't match");
				}
				else if(code === "auth/invalid-email") {
					throw new Error("Invalid e-mail provided");
				}
				else if(code === "auth/weak-password") {
					throw new Error("Password is too weak");
				}
			}
		}
	}
	async signInEmail(email, password) {
		if(email.length === 0 || password.length === 0) {
			throw new Error("Please fill all the fields");
		}
		else {
			try {
				await firebase.auth().signInWithEmailAndPassword(email, password);
			}
			catch({ code }) {
				if(code === "auth/user-disabled") {
					throw new Error("This user has been disabled");
				}
				else if(code === "auth/invalid-email") {
					throw new Error("Invalid e-mail provided");
				}
				else if(code === "auth/user-not-found") {
					throw new Error("Can't find that user");
				}
				else if(code === "auth/wrong-password") {
					throw new Error("Incorrect password");
				}
			}
		}
	}
	async authorizeFacebook() {
		try {
			const provider = new firebase.auth.FacebookAuthProvider();

			const userCredentials = await firebase.auth().signInWithPopup(provider);

			await firebase.firestore().collection("users").doc(userCredentials.user.uid).set({
				name: userCredentials.user.displayName
			})
		}
		catch({ code }) {
			if(code === "auth/account-exists-with-different-credential") {
				throw new Error("This account already exists with a different authentication method.");
			}
			else {
				throw new Error("An error has occured. Please try again later.");
			}
		}
	}
	async authorizeGoogle() {
		try {
			const provider = new firebase.auth.GoogleAuthProvider();

			const userCredentials = await firebase.auth().signInWithPopup(provider);

			await firebase.firestore().collection("users").doc(userCredentials.user.uid).set({
				name: userCredentials.user.displayName
			})
		}
		catch({ code }) {
			if(code === "auth/account-exists-with-different-credential") {
				throw new Error("This account already exists with a different authentication method.");
			}
			else {
				throw new Error("An error has occured. Please try again later.");
			}
		}
	}
	async authorizeYahoo() {
		try {
			const provider = new firebase.auth.OAuthProvider('yahoo.com');

			const userCredentials = await firebase.auth().signInWithPopup(provider);

			await firebase.firestore().collection("users").doc(userCredentials.user.uid).set({
				name: userCredentials.user.displayName
			});
		}
		catch({ code }) {
			if(code === "auth/account-exists-with-different-credential") {
				throw new Error("This account already exists with a different authentication method.");
			}
			else if(code === "auth/popup-closed-by-user") {
				throw new Error("Popup closed by user.");
			}
			else if(code === "auth/popup-blocked") {
				throw new Error("Popup was blocked.");
			}
			else {
				throw new Error("An error has occured. Please try again later.");
			}
		}
	}
}